/* eslint no-console: 0, no-native-reassign: 0, no-undef: 0 */
/* global Stripe, listingJSON */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { InboxPanel } from './inbox-panel';
import { PaginationBtn } from '../elements-buttons/pagination-button';
import { Placeholder } from '../elements-placeholder/placeholder';
import { Link } from 'react-router';
import { TabsContainer } from './tabs-container';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import CalendarAvailabilityModal from '../app-host-calendar/confirm-availability-modal';

export class InboxContainer extends React.Component {
  constructor (props) {
    super(props);

    this.renderInbox = this.renderInbox.bind(this);
  }

  renderInbox (grayBg) {
    const { body, placeholder } = this.props;
    if (body && (0 < body.length)) {
      return body.map((props, i) => {
        const bookingId = props.details.booking_id;
        const country = get(props.details, 'listing.country', '');
        return (
          <Link
            key={`inbox-${i}`}
            to={`/inbox/${bookingId}`}
            className={classnames('inbox-panel-row text-gray-darker margin-md-bottom', { 'bg-gray-100': grayBg })}
          >
            <SharedIntlProviderHOC>
              <InboxPanel {...props} />
            </SharedIntlProviderHOC>
          </Link>
        );
      });
    }
    return <Placeholder {...placeholder} />;
  }

  render () {
    const { tabs, body, location, paginate, pageNumber, limit, totalCount, isLoading, showResponsive, hostResponse } = this.props;
    return (
      <div className="inbox-section">
        <TabsContainer
          loc={location}
          tabs={tabs}
          showResponsive={showResponsive}
          hostResponse={hostResponse}
        />
        <div className="body-container">
          {
            isLoading
              ? <div className="heavy">
                <FormattedMessage
                  id='invite.inbox_container.loading'
                  defaultMessage='Loading Messages...'
                />
              </div>
              : this.renderInbox('grayBg')
          }
        </div>
        {
          (0 < totalCount) && (limit < totalCount) && (!isLoading)
            ? <PaginationBtn
              first
              last
              page={pageNumber}
              maxButtons={4}
              paginate={paginate}
              limit={limit}
              pageCount={body.length}
              totalCount={totalCount}
            /> : null
        }
        <CalendarAvailabilityModal />
      </div>
    );
  }
}

InboxContainer.propTypes = {
  body: PropTypes.array,
  tabs: PropTypes.array,
  location: PropTypes.string,
  placeholder: PropTypes.object,
  paginate: PropTypes.func,
  page: PropTypes.string,
  limit: PropTypes.number,
  pageNumber: PropTypes.number,
  totalCount: PropTypes.number,
  isLoading: PropTypes.bool,
  hostResponse: PropTypes.object
};
